import { MessageCircle } from "lucide-react";
import { openWhatsApp } from "@/utils/whatsapp";
import { getReferralCode } from "@/utils/referral";

export const WhatsAppButton = () => {
  const handleClick = () => {
    const ref = getReferralCode();
    let message = "Hola! Me interesa ver su catalogo de ropa en Original y Barato.";
    if (ref) message += `\n\nReferido por: ${ref}`;
    openWhatsApp(message);
  };

  return (
    <button
      onClick={handleClick}
      className="whatsapp-float"
      aria-label="Contactar por WhatsApp"
      data-testid="whatsapp-float-btn"
    >
      <MessageCircle className="w-7 h-7 text-white" fill="white" />
    </button>
  );
};
